type JourneyCycleHeaderProps = {
  label: string;
};

export const JourneyCycleHeader = ({ label }: JourneyCycleHeaderProps) => (
  <div className="t-flex t-items-center t-gap-3 t-pb-3 t-text-body-sm t-text-text-30">
    <span className="t-uppercase t-whitespace-nowrap">{label}</span>
    <div className="t-flex-1 t-h-px t-bg-separator-fade-right t-opacity-40" />
  </div>
);
